import React from "react";
import { useEntity } from "../../entity/useEntity";
import { EntityGeneralSettings } from "./EntityGeneralSettings";

export const EntitySettings: React.FC = () => {
    const entity = useEntity();

    return (
        <>
            <header className="settings__header">
                <div>
                    <h3>{entity.name}</h3>
                </div>
            </header>
            <EntityGeneralSettings />
        </>
    );
};
